import React from "react";
import { Crown } from "lucide-react";
import { ACADEMY_LOGO_H } from "../../data/assets";

// Shared Next O Technical Academy print primitives (Ball Mastery Vol. 1 design language): Matte Black · Crimson · Metallic Gold.
export const GOLD = "#D4AF37", RED = "#C41E24", INK = "#0b0b0d", PANEL = "rgba(18,18,20,0.95)";
export const GOLD_GRAD = `linear-gradient(135deg, #F0D77A, ${GOLD} 60%, #B8912E)`;
export const RED_GRAD = `linear-gradient(160deg, #e03a40, ${RED})`;

export const Page = ({ children, n, footer, testid, width = "8.5in", height = "11in", pad = "0.55in", dark = false }) => (
  <section data-testid={testid} className={`print-page relative overflow-hidden text-white ${dark ? "elite-carbon-bg grain" : ""}`} style={{ width, height, background: dark ? undefined : INK }}>
    <div className="absolute inset-x-0 top-0 h-[3px]" style={{ background: `linear-gradient(90deg, ${RED}, ${GOLD} 50%, ${RED})` }} />
    <div className="relative h-full flex flex-col" style={{ padding: `0.45in ${pad} 0.62in` }}>{children}</div>
    <div className="absolute inset-x-0 bottom-0 h-[0.42in] flex items-center justify-between font-mono text-[7.5px] uppercase tracking-[0.3em] text-white/40 border-t" style={{ borderColor: `${GOLD}2a`, paddingLeft: pad, paddingRight: pad }}>
      <span className="flex items-center gap-2 whitespace-nowrap"><img src={ACADEMY_LOGO_H} alt="The Next O Technical Academy" style={{ height: 14, opacity: 0.9 }} /> {footer}</span>
      <span className="whitespace-nowrap">Coach Barker | Next O Soccer</span>
      <span className="whitespace-nowrap" style={{ color: GOLD }}>{n !== undefined ? String(n).padStart(2, "0") : "hub.nextosoccer.com"}</span>
    </div>
  </section>
);

export const DocHeader = ({ title, right = "hub.nextosoccer.com", logoH = 40 }) => (
  <div className="flex items-end justify-between pb-3 border-b" style={{ borderColor: `${GOLD}66` }}>
    <img src={ACADEMY_LOGO_H} alt="The Next O Technical Academy" style={{ height: logoH }} />
    <div className="text-right font-mono text-[8.5px] font-bold uppercase tracking-[0.3em]" style={{ color: GOLD }}>
      Next O Technical Academy <span className="text-white/35 mx-1">|</span> {title} <span className="text-white/35 mx-1">|</span> <span className="text-white/70">{right}</span>
    </div>
  </div>
);

export const Kicker = ({ children }) => <div className="flex items-center gap-2 font-mono text-[8.5px] font-bold uppercase tracking-[0.45em]" style={{ color: GOLD }}><Crown size={10} /> {children}</div>;
export const H1 = ({ children, size = 34 }) => <h2 className="font-cover uppercase leading-[0.9] mt-2" style={{ fontSize: size }}>{children}</h2>;
export const Lede = ({ children, className = "" }) => <p className={`text-[10.5px] text-white/60 mt-2 leading-relaxed max-w-[5.6in] ${className}`}>{children}</p>;

export const SectionHead = ({ n, children, sub }) => (
  <div className="flex items-center gap-3 mt-4 mb-2">
    <span className="w-8 h-8 rounded-sm flex items-center justify-center font-cover text-xl text-black shrink-0" style={{ background: GOLD_GRAD }}>{n}</span>
    <div className="min-w-0">
      <div className="font-headings text-[17px] uppercase tracking-wide leading-none" style={{ color: GOLD }}>{children}</div>
      {sub && <div className="font-mono text-[7px] uppercase tracking-[0.3em] text-white/45 mt-1">{sub}</div>}
    </div>
    <span className="flex-1 h-px" style={{ background: `linear-gradient(90deg, ${RED}, ${GOLD}55, transparent)` }} />
  </div>
);

export const Lines = ({ n = 3, h = 22, className = "" }) => <div className={className}>{Array.from({ length: n }).map((_, i) => <div key={i} style={{ height: h, borderBottom: "1px solid rgba(255,255,255,0.22)" }} />)}</div>;

export const Field = ({ label, className = "", h = 22, accent = false }) => (
  <div className={`min-w-0 ${className}`}>
    <div className="font-mono text-[7px] font-bold uppercase tracking-[0.3em]" style={{ color: accent ? "#ff8a8e" : GOLD }}>{label}</div>
    <div style={{ height: h, borderBottom: `1px solid ${accent ? RED : "rgba(255,255,255,0.35)"}` }} />
  </div>
);

export const Check = ({ children, size = 11 }) => (
  <span className="inline-flex items-center gap-2 text-[9.5px] text-white/85 leading-none"><span className="inline-block rounded-[2px] shrink-0" style={{ width: size, height: size, border: `1.2px solid ${GOLD}` }} />{children}</span>
);

export const PageStyle = ({ w = "8.5in", h = "11in" }) => <style>{`@page { size: ${w} ${h}; margin: 0; } .print-page { break-after: page; } .print-page:last-child { break-after: auto; page-break-after: auto !important; }`}</style>;
